



























































































































import { Vue, Component, Mixins } from "vue-property-decorator";
import Search from "@/components/elements/utility/Search.vue";
import DataTable from "@/components/elements/utility/Table.vue";
import CustomerService from "@/services/customer_service";
import { Customer } from "@/models/customer/customer";
import { makeTitleCase } from "@/utility/helpers";
import { namespace } from "vuex-class";
import { StoreModule } from "@/store/types";
import { OrderActions, OrderGetters } from "@/store/modules/order/types";
import { LineItem } from "@/models/order/order";
import ConfirmNewQuote from "@/components/elements/modal/ConfirmNewQuote.vue";
import { Mobile } from "@/mixins/mobile";
import { GlobalActions } from "@/store/modules/global/types";

@Component({
  components: {
    Search,
    DataTable,
    ConfirmNewQuote,
  },
})
export default class CustomerList extends Mixins(Mobile) {
  @(namespace(StoreModule.Order).Action(OrderActions.ClearOrder))
  resetOrder!: () => Promise<void>;
  @(namespace(StoreModule.Order).Getter(OrderGetters.GetOrderItems))
  items!: LineItem[];
  @(namespace(StoreModule.Global).Action(GlobalActions.AddMultiplier))
  addMultiplier!: (value: number) => Promise<void>;
  @(namespace(StoreModule.Order).Action(OrderActions.AssignCustomer))
  assignCustomer!: (value: {
    customer_id: string;
    customer_name: string;
    order_id: string | null;
  }) => Promise<void>;
  protected selected: {
    customer_id: string;
    customer_name: string;
    multiplier: number;
  } | null = null;
  private search = "";
  protected makeTitleCase = makeTitleCase;
  protected fields = [
    "customer_name",
    "store_name",
    // "email",
    // "address",
    "location",
    "phone",
    // "website_url",
  ];
  protected customerService = new CustomerService();
  protected customers: Customer[] = [];
  protected showModal = false;

  async created() {
    this.customers = await this.customerService.getCurrentCustomers();
  }

  protected close(): void {
    this.showModal = false;
    this.selected = null;
  }

  protected async clearOrder(): Promise<void> {
    await this.resetOrder();
    await this.reassignQuote(
      this.selected?.customer_id!,
      this.selected?.customer_name!,
      this.selected?.multiplier!
    );
  }

  protected toggleNewQuoteModal(
    customerId: string,
    customerName: string,
    customerMultiplier: number
  ): void {
    this.selected = {
      customer_id: customerId,
      customer_name: customerName,
      multiplier: customerMultiplier,
    };
    if (this.items.length > 0) {
      // only toggling warning modal if there is an item associated with the order
      this.showModal = true;
    } else {
      this.reassignQuote(
        this.selected?.customer_id!,
        this.selected?.customer_name!
      );
    }
  }

  protected async reassignQuote(
    customerId?: string,
    customerName?: string,
    customerMultiplier?: number
  ) {
    const id = customerId ? customerId : this.selected?.customer_id!;
    const name = customerName ? customerName : this.selected?.customer_name!;
    const multiplier = customerMultiplier
      ? customerMultiplier
      : this.selected?.multiplier!;
    await this.assignCustomer({
      customer_id: id,
      customer_name: name,
      order_id: null,
    });
    this.addMultiplier(multiplier);
    this.close(); // sets selected to null, must be called last
    this.$router.push("/");
  }

  // Triggered from child component, <Search />
  protected submitSearch(searchTerm: string): void {
    this.search = searchTerm;
  }

  protected formatHeaders(header: string): string {
    let formatted = "";
    switch (header) {
      case "store_name":
        formatted = "Primary Company Name";
        break;
      case "customer_name":
        formatted = "Customer";
        break;
      case "sales_contacts":
        formatted = "Contact";
        break;
      default:
        formatted = this.makeTitleCase(header);
        break;
    }
    return formatted;
  }

  /** Remove unneeded fields from fetched data & perform search before returning data to view */
  get filteredCustomers() {
    this.customers = this.customers.map((c) => {
      c.sales_region = this.makeTitleCase(c.sales_region) as any;
      return c;
    });
    if (this.search != "") {
      const filter = (this.customers as any[]).filter((item) => {
        return (
          item.customer_name
            .toLowerCase()
            .indexOf(this.search.toLowerCase()) !== -1
        );
      });
      return filter;
    } else {
      return this.customers;
    }
  }
}
